/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 01/09/2025 - 14:13:55
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 01/09/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface TermsModalProps {
  show: boolean;
  onHide: () => void;
  onAccept: () => void;
}

const TermsAndConditionsModal: React.FC<TermsModalProps> = ({
  show,
  onHide,
  onAccept,
}) => {
  const [accepted, setAccepted] = useState(false);
  const { t } = useTranslation();
  
  const handleAccept = () => {
    if (accepted) {
      onAccept();
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <div className="modal-container" style={{
        backgroundColor: "white",
        borderRadius: "8px",
        maxWidth: "800px",
        width: "90%",
        maxHeight: "90vh",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
      }}>
        <div className="modal-header" style={{
          padding: "16px",
          borderBottom: "1px solid #e0e0e0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <h3 style={{ margin: 0 }}>{t("General Terms and Conditions")}</h3>
          <button 
            onClick={onHide}
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer"
            }}
          >
            ×
          </button>
        </div>
        
        <div className="modal-body" style={{ padding: "16px", overflowY: "auto" }}>
          <div className="terms-content" style={{maxHeight: "400px", overflowY: "auto"}}>
            <h4>General Terms and Conditions (GTC) of getXdone GmbH for the GlareCheck service</h4>
            
            <h5>Description of the services</h5>
            <p>GlareCheck is a service of getXdone GmbH (hereinafter "we", "us" or "provider"), which was developed to analyze and evaluate possible glare effects caused by sunlight. GlareCheck enables users to carry out glare analyses and to generate corresponding reports. The service is accessible via the website https://pv-glarecheck.com/.</p>
            <p><strong>Please note:</strong> The use of GlareCheck is currently not permitted in the United States of America (USA).</p>
            
            <h5>Registration and acceptance of the terms of use</h5>
            <p>The use of GlareCheck requires the creation of a user account. Any natural or legal person can open a user account. When the account is opened, personal data such as name, email address and other information are requested. The user is obliged to provide correct and complete information. By opening a user account and using the service, the user accepts these terms and conditions.</p>
            
            <h5>Disclaimer of liability</h5>
            <p>(1) Liability for content: We accept no liability for the accuracy, completeness or timeliness of the content provided. The use of the content of the service is at the user's own risk. In particular, we assume no liability for direct or indirect damage caused by the use of the information provided.</p>
            <p>(2) Liability for technical availability: We do not guarantee the uninterrupted availability of the service and are not liable for technical failures, malfunctions or interruptions. Planned maintenance work, security updates or force majeure can lead to temporary restrictions or failures for which we assume no liability.</p>
            <p>(3) Liability for links: Our service may contain links to external websites of third parties, the content of which we have no influence on. The respective provider or operator of the pages is always responsible for the content of the linked pages. We accept no liability for the content of external links.</p>
            
            <h5>User requirements and obligations</h5>
            <p>(1) The user is obliged to keep his access data safe and not to pass it on to third parties. The user is responsible for all activities that are carried out using his access data.</p>
            <p>(2) The user undertakes to use the service only within the framework of the statutory provisions and these terms and conditions. Any improper use of the service is prohibited.</p>
            <p>(3) The user may not post or distribute content that violates applicable law or the rights of third parties. We reserve the right to remove such content without notice and to block the user's access.</p>
            
            <h5>Data protection</h5>
            <p>The protection of personal data is important to us. Details on the collection, processing and use of personal data can be found in our data protection declaration, which is available on the website https://pv-glarecheck.com/.</p>
            
            <h5>Change of terms and conditions</h5>
            <p>We reserve the right to change these terms and conditions at any time with future effect. We will inform users in good time about changes to the terms and conditions. The changes are considered accepted if the user does not object to the change notification within 14 days of receipt. If the user objects, we reserve the right to terminate the license agreement.</p>
            
            <h5>Termination</h5>
            <p>(1) The user can terminate his user account at any time without giving reasons. Termination is possible via the corresponding functions on the website.</p>
            <p>(2) We reserve the right to terminate the license agreement for an important reason, in particular in the event of violations of these terms and conditions or applicable law.</p>
            
            <h5>Final provisions</h5>
            <p>(1) The law of the Federal Republic of Germany applies to the exclusion of the UN Sales Convention.</p>
            <p>(2) The place of performance and jurisdiction for all disputes arising from the license agreement is the seat of getXdone GmbH, provided the user is a merchant or has no general place of jurisdiction in Germany.</p>
            <p>(3) Should a provision of these terms and conditions be or become ineffective or unenforceable, the effectiveness of the remaining provisions remains unaffected. The ineffective provision is replaced by an effective one that comes as close as possible to the economic purpose of the ineffective provision.</p>
            <p>(4) There are no side agreements to these terms and conditions. Changes and additions must be in writing.</p>
            
            <p><em>As of August 2025</em></p>
          </div>
          
          <div className="checkbox-container" style={{ marginTop: "16px" }}>
            <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
              <input 
                type="checkbox" 
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                style={{ marginRight: "8px" }}
              />
              {t("I have read and accept the Terms and Conditions")}
            </label>
          </div>
        </div>
        
        <div className="modal-footer" style={{
          padding: "16px",
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          justifyContent: "flex-end",
          gap: "8px"
        }}>
          <button 
            onClick={onHide}
            style={{
              padding: "8px 16px",
              backgroundColor: "#f5f5f5",
              border: "1px solid #ccc",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            {t("Cancel")}
          </button>
          <button 
            onClick={handleAccept}
            disabled={!accepted}
            style={{
              padding: "8px 16px",
              backgroundColor: accepted ? "#007bff" : "#cccccc",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: accepted ? "pointer" : "not-allowed"
            }}
            className={accepted ? "PO-card-purchaseFullReport" : ""}
          >
            {t("Accept and Continue")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsModal;